import React, { useState,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/appLogo.png';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Divider from './common/Divider';
import { message } from '../messages/Message';
import showIcon from '../../assets/hideIcon.png';
import closeIcon from '../../assets/showIcon.png';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { resetPassword } from '../services/operations/authAPI';
import Loader from '../Loader/Loader';

const schema = yup.object().shape({
  password: yup.string()
    .required(message.passwordRequiredMessage)
    .min(8, message.passwordMinMessage)
    .matches(
      /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^\w])[A-Za-z\d\W_]{8,}$/,
      message.passwordMatchMessage
    ),
    confirmPassword: yup.string()
    .oneOf([yup.ref('password'), null], message.matchMessage)
    .required(message.confirmPasswordRequiredMessage),
});

const ChangePassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { register, handleSubmit, watch, formState: { errors, isValid }, trigger } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    shouldUnregister: false, 
  });

  const navigate = useNavigate();
  const location=useLocation();
  const dispatch = useDispatch();
  const loading=useSelector((state)=>state.auth.loading)

  const password = watch('password');
  const confirmPassword = watch('confirmPassword');
  const queryParams = new URLSearchParams(window.location.search);

  const token = queryParams.get('token');
  const base64Param = queryParams.get('data');
  const email = base64Param ? atob(base64Param) : '';


  const [isConfirmTouched, setIsConfirmTouched] = useState(false);
  const passwordValue = watch("password");

  useEffect(() => {
    if (confirmPassword) {
      trigger("confirmPassword");
    }
  }, [passwordValue, confirmPassword, trigger]);


  const onSubmit = async (data) => {
    const { password, confirmPassword } = data;

    const encodedPassword = btoa(password);
    const encodedConfirmPassword = btoa(confirmPassword);

    const payload = {
      password: encodedPassword,
      password_confirmation: encodedConfirmPassword,
      token:token,
      email:email
    };
    await dispatch(resetPassword(payload,navigate));
  };

  return (
    <div className='login-page'>
      {loading && <Loader/>}
      <div className='login-header'>
        <img src={logo} alt='app-logo-login' style={{ cursor: "pointer" }} onClick={() => navigate('/')} />
        <p className="login-header-desc" style={{width:"70%",fontSize:"18px",lineHeight:"28px"}}>
          Create a new password that is different from any of your previously used passwords to ensure your account remains secure.
        </p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="login-form">
        <div className="login-form-group">
          <label htmlFor="password" className="form-label">Password</label>
          <div className="password-input-wrapper" style={{height:"60px"}}>
            <input
              type={showPassword ? 'text' : 'password'}
              id="password"
               style={{ width: "100%" ,height:"60px"}}
              maxLength={20}
              className={`form-input-login ${errors.password ? 'input-error' : ''}`}
              {...register('password')}
            />
            <span className="password-toggle-icon"
            style={{top:"17px",right:"15px"}}
             onClick={() => setShowPassword(!showPassword)}>
              <img src={showPassword ? showIcon : closeIcon} alt={showPassword ? 'hide' : 'show'} />
            </span>
          </div>
          {errors.password && <p className="error-message">{errors.password.message}</p>}
        </div>

        <div className="login-form-group">
          <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
          <div className="password-input-wrapper">
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              id="confirmPassword"
              style={{ width: "100%" ,height:"60px"}}
              className={`form-input-login ${errors.confirmPassword ? 'input-error' : ''}`}
              {...register('confirmPassword')}
              
            />
            <span className="password-toggle-icon"
            style={{top:"17px",right:"15px"}}
             onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
              <img src={showConfirmPassword ? showIcon : closeIcon} alt={showConfirmPassword ? 'hide' : 'show'} />
            </span>
          </div>
          {errors.confirmPassword ? (
            <p className="error-message">{errors.confirmPassword.message}</p>
          ) : (
            password && confirmPassword && password === confirmPassword && (
              <p className="success-message" style={{ color: 'green', fontSize: "small" }}>Password matched</p>
            )
          )}
        </div>

        <button 
          type="submit" 
          className={`button-theme ${isValid ? "button-enabled" : "button-disabled"}`}
          disabled={!isValid}
        >
          Continue
        </button>
      </form>
    </div>
  );
};

export default ChangePassword;
